export enum Policy {
  canCreate,
  canCreateLegacy,
  canRead,
  canReadHistory,
  canReadSoftDeleted,
  canUpdateBasic,
  canUpdateElevated,
  canDeleteSoft,
  canDeleteHard,
  canDeleteHardLegacy,
  canRestore,
  canImport,
  canCreateSwPartNumber,
  canDeleteSoftSwPartNumber,
  notAuthorized,
  canDeleteSoftAndRestoreLegacy,
  canDownloadApiCallLogs,
  canCreateSwPartNumberSnapshot,
  canReleaseSwPartNumberSnapshot,
  canUpdateTranslations,
  canImportErrorCodes,
  canImportAlarmMasks,
  canCreateAfterSalesDtcReviewRequests,
  canCreateTechnicalOrganisationDtcReviewRequests,
  canDeleteAfterSalesDtcReviewRequests,
  canDeleteTechnicalOrganisationDtcReviewRequests,
  canUpdateInternalNotes,
  canMergeDtcReviewRequests,
  canDeleteDtcReviewRequests,
  canUpsertFieldHelp,
  canResetTrReviewFlags,
  canCreateNwNumber,
  canPublishSyncEvents,
}
